import { useState, useEffect, useRef } from 'react';
import { Header } from '../../common/Header/Header.jsx';
import { SelectPerPage } from '../../common/Forms/Input/Input.jsx';
import { AdvancedPaymentsTable } from '../../common/Tables/Tables.jsx';
import { advancedPaymentsTableHeader } from '../../../assets/helpers/tables.js';
import { notify } from '../../../assets/helpers/toast.js';
import { salesRoles } from '../../../assets/helpers/roles.js';
import {
  FilterDatePicker,
  SearchInput,
} from '../../common/Forms/Input/Input.jsx';
import moment from 'moment';
import {
  filterById,
  filterParams,
  NaNtoNumber,
} from '../../../assets/helpers/funciones.js';
import './AdvancedPayments.scss';
import authService from '../../../services/authService.js';
import { paymentsService } from '../../../services/paymentsService.js';
import {
  AdvancedPaymentModal,
  ValidatePaymentModal,
} from '../../common/Modals/Modals.jsx';
import { ActionButton } from '../../common/Buttons/Buttons.jsx';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as schemas from '../../../assets/schemas/schemas.js';
import { usersService } from '../../../services/usersService.js';
import { currencyRateService } from '../../../services/currencyRateService.js';
import { productService } from '../../../services/productService.js';
import {
  paymentMethods,
  paymentType,
} from '../../../assets/helpers/options.js';
import { bancamigaService } from '../../../services/bancamigaService.js';
import { LoadSpinner } from '../../common/LoadSpinner/LoadSpinner.jsx';

const itemsPerpage = [10, 25, 50, 100, 500];

export const AdvancedPayments = () => {
  const tableRef = useRef(null);
  const user = authService.getUser();
  const userRole = user.roles[0].code;
  const [isLoading, setIsLoading] = useState(false);
  const [validatePaymentModal, setValidatePaymentModal] = useState({
    isOpen: false,
    id: '',
  });
  const [sellers, setSellers] = useState([]);
  const [dollarByDate, setDollarByDate] = useState('');
  const [salesPaymentMethods, setSalesPaymentMethods] = useState([]);
  const [addFilesUploaded, setAddFilesUploaded] = useState([]);
  const [showEditModal, setShowEditModal] = useState({
    isOpen: false,
    id: '',
  });
  const [showAddModal, setShowAddModal] = useState(false);
  const [dateFrom, setDateFrom] = useState(
    new Date(moment().subtract(1, 'months'))
  );
  const [dateTo, setDateTo] = useState(new Date(moment()));
  const [advancedPaymentsTable, setAdvancedPaymentsTable] = useState({
    limit: itemsPerpage[2],
    offset: 0,
    data: [],
    count: 0,
    page: 1,
    dateFrom: '',
    dateTo: '',
    isLoading: false,
    searchParam: '',
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    resetField,
    watch,
    reset,
    control,
  } = useForm({
    resolver: yupResolver(schemas.createAdvancedPayments()),
  });

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    setValue: setValue2,
    getValues: getValues2,
    resetField: resetField2,
    watch: watch2,
    reset: reset2,
    control: control2,
  } = useForm({
    resolver: yupResolver(schemas.editAdvancedPayments()),
  });

  const setFirstPage = () => {
    setAdvancedPaymentsTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
      };
    });
  };

  const handleSinceDateChange = (e) => {
    if (e > dateTo && dateTo) {
      notify('Ingrese una fecha en un rango valido ', 'info');
    } else {
      setFirstPage();
      setDateFrom(e);
    }
  };

  const handleUntilDateChange = (e) => {
    if (e < dateFrom && dateFrom) {
      notify('Ingrese una fecha en un rango valido ', 'info');
    } else {
      setDateTo(e);
      setFirstPage();
    }
  };

  const selectitemsPerpage = (event) => {
    setAdvancedPaymentsTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const handlePageChange = (event, value) => {
    setAdvancedPaymentsTable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * advancedPaymentsTable?.limit,
      };
    });
  };

  const handleSearchChange = (event) => {
    setAdvancedPaymentsTable((prevState) => {
      return {
        ...prevState,
        searchParam: event?.target?.value,
        page: 1,
        offset: 0,
        data: false,
      };
    });
  };

  const formatSellers = (arr) => {
    let data = [];
    for (let i = 0; i < arr?.length; i++) {
      data.push({
        name: `${arr[i]?.firstName} ${arr[i]?.lastName}`,
        _id: arr[i]?._id,
      });
    }
    data = data
      .filter(
        (item, index, self) =>
          self.findIndex((t) => t._id === item._id) === index
      )
      .sort((a, b) => a.name.localeCompare(b.name));
    return data;
  };

  const addAdvancedPayment = handleSubmit(async (data) => {
    const formData = new FormData();
    formData.append(`paymentMethod`, watch(`method`));
    if (watch(`phone`)) {
      formData.append(`phoneNumber`, watch(`phone`));
    }
    if (watch(`bank`)) {
      formData.append(`clientBankCode`, watch(`bank`));
    }

    if (watch(`clientName`)) {
      formData.append(`customerName`, watch(`clientName`));
    }
    if (watch(`paymentType`)) {
      formData.append(`paymentType`, watch(`paymentType`));
    }
    if (watch(`casheaRef`)) {
      formData.append(`casheaRef`, watch(`casheaRef`));
    }
    if (watch(`clientPhone`)) {
      formData.append(`clientPhone`, watch(`clientPhone`));
    }

    formData.append(`reference`, watch(`reference`));
    formData.append(`responsibleAdvisor`, watch(`seller`));
    formData.append(`identification`, watch(`identification`));
    formData.append(`identificationType`, watch(`identificationType`));

    if (showAddAccHolder()) {
      formData.append(`accHolder`, watch(`reference`));
    }
    formData.append(`amount`, NaNtoNumber(parseFloat(watch(`amount`))));
    formData.append(`amountBsS`, watch(`amountBsS`));
    formData.append(
      `paymentDate`,
      moment(watch('paymentDate'))?.format('YYYY-MM-DD')
    );
    if (addFilesUploaded[0]) {
      formData.append(`paymentEvidence`, addFilesUploaded[0]);
    }

    if (isBancamigaPM(salesPaymentMethods, watch('method'))) {
      let PMData = {
        date: watch('paymentDate')
          ? moment(watch('paymentDate')).format('YYYY-MM-DD')
          : '',
        bank: watch(`bank`) ? watch(`bank`) : '',
        phone: watch(`clientPhone`) ? '58' + watch(`clientPhone`) : '',
        reference: watch(`reference`),
        method: watch(`method`),
      };
      const validate = await validateBancamigaPM(PMData);

      if (validate) {
        if (!isLoading && formData) {
          setIsLoading(true);
          paymentsService
            .createAdvancedPayment(formData)
            .then((response) => {
              if ([200, 201].includes(response.status)) {
                notify(`Pago Realizado con exito`, 'success');
                getAdvancedPayments();
                reset();
                setShowAddModal(false);
                setIsLoading(false);
              } else {
                notify(`${response.message}`, 'error');
                setIsLoading(false);
              }
            })
            .catch((error) => {
              setIsLoading(false);
            });
        }
      } else {
        return false;
      }
    } else {
      if (!isLoading && formData) {
        setIsLoading(true);
        paymentsService
          .createAdvancedPayment(formData)
          .then((response) => {
            if ([200, 201].includes(response.status)) {
              notify(`Pago Realizado con exito`, 'success');
              getAdvancedPayments();
              reset();
              setShowAddModal(false);
              setIsLoading(false);
            } else {
              notify(`${response.message}`, 'error');
              setIsLoading(false);
            }
          })
          .catch((error) => {
            setIsLoading(false);
          });
      }
    }
  });

  const editAdvancedPayment = handleSubmit2(async (data) => {
    const formData = new FormData();
    if (watch2(`method`)) {
      formData.append(`paymentMethod`, watch2(`method`));
    }
    if (watch2(`phone`)) {
      formData.append(`phoneNumber`, watch2(`phone`));
    }
    if (watch2(`paymentType`)) {
      formData.append(`paymentType`, watch2(`paymentType`));
    }
    if (watch2(`casheaRef`)) {
      formData.append(`casheaRef`, watch2(`casheaRef`));
    }
    if (watch2(`bank`)) {
      formData.append(`clientBankCode`, watch2(`bank`));
    }
    if (watch2(`clientName`)) {
      formData.append(`customerName`, watch2(`clientName`));
    }
    if (watch2(`clientPhone`)) {
      formData.append(`clientPhone`, watch2(`clientPhone`));
    }

    if (watch2(`reference`)) {
      formData.append(`reference`, watch2(`reference`));
      if (showAddAccHolder()) {
        formData.append(`accHolder`, watch2(`reference`));
      }
    }

    if (watch2(`identification`)) {
      formData.append(`identification`, watch2(`identification`));
    }
    if (watch2(`identificationType`)) {
      formData.append(`identificationType`, watch2(`identificationType`));
    }
    if (watch2(`seller`)) {
      formData.append(`responsibleAdvisor`, watch2(`seller`));
    }
    if (watch2(`amount`)) {
      formData.append(`amount`, NaNtoNumber(parseFloat(watch2(`amount`))));
    }

    if (watch2(`amountBsS`)) {
      formData.append(`amountBsS`, watch2(`amountBsS`));
    }
    if (watch2('paymentDate')) {
      formData.append(
        `paymentDate`,
        moment(watch2('paymentDate'))?.format('YYYY-MM-DD')
      );
    }

    if (isBancamigaPM(salesPaymentMethods, watch2('method'))) {
      let PMData = {
        date: watch2('paymentDate')
          ? moment(watch2('paymentDate')).format('YYYY-MM-DD')
          : '',
        bank: watch2(`bank`) ? watch2(`bank`) : '',
        phone: watch2(`clientPhone`) ? '58' + watch2(`clientPhone`) : '',
        reference: watch2(`reference`),
        method: watch2(`method`),
      };
      const validate = await validateBancamigaPM(PMData);

      if (validate) {
        if (!isLoading && formData) {
          setIsLoading(true);
          paymentsService
            .updateAdvancedPayment(showEditModal.id, formData)
            .then((response) => {
              if ([200, 201].includes(response.status)) {
                notify(`Pago Editado con exito`, 'success');
                getAdvancedPayments();
                reset2();
                setShowEditModal((prev) => {
                  return { ...prev, isOpen: false, id: '' };
                });
                setIsLoading(false);
              } else {
                notify(`${response.message}`, 'error');
                setIsLoading(false);
              }
            })
            .catch((error) => {
              setIsLoading(false);
            });
        }
      } else {
        return false;
      }
    } else {
      if (!isLoading && formData) {
        setIsLoading(true);
        paymentsService
          .updateAdvancedPayment(showEditModal.id, formData)
          .then((response) => {
            if ([200, 201].includes(response.status)) {
              notify(`Pago Editado con exito`, 'success');
              getAdvancedPayments();
              reset2();
              setShowEditModal((prev) => {
                return { ...prev, isOpen: false, id: '' };
              });

              setIsLoading(false);
            } else {
              notify(`${response.message}`, 'error');
              setIsLoading(false);
            }
          })
          .catch((error) => {
            setIsLoading(false);
          });
      }
    }
  });

  const getSellers = () => {
    usersService
      .getSalesUsers({
        status: 'Activo',
        module: 'Ventas',
      })
      .then((response) => {
        if (response.status === 200) {
          if (response?.data?.length === 0) {
            notify('No hay asesores disponibles', 'info');
          }
          const cleanData = formatSellers(response?.data.users);
          setSellers(cleanData);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => {
        notify('Error al consultar asesores', 'error');
      });
  };

  const getDollarRateByDate = (date) => {
    let params = {
      currency: 'USD',
      date: moment(date).format('YYYY-MM-DD'),
      limit: 20,
    };

    currencyRateService
      .getCurrencyRates(params)
      .then((response) => {
        if (response.status === 200) {
          if (showAddModal) {
            setValue(
              'amountBsS',
              (
                Number(watch('amount')) * response?.data?.result[0]?.rate
              )?.toFixed(2)
            );
          }

          if (showEditModal.isOpen) {
            setValue2(
              'amountBsS',
              (
                Number(watch2('amount')) * response?.data?.result[0]?.rate
              )?.toFixed(2)
            );
          }
          setDollarByDate(response?.data?.result[0]?.rate);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => { });
    return true;
  };

  const getPaymentMethods = () => {
    productService
      .getPaymentMethods('sales')
      .then((response) => {
        if (response.status === 200) {
          setSalesPaymentMethods(response?.data);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => { });
  };

  const handleAddAmountChange = () => {
    setValue('amountBsS', (watch('amount') * dollarByDate)?.toFixed(2));
  };

  const handleEditAmountChange = () => {
    setValue2('amountBsS', (watch2('amount') * dollarByDate)?.toFixed(2));
  };

  const handleAddBsChange = () => {
    setValue('amount', (watch('amountBsS') / dollarByDate)?.toFixed(2));
  };

  const handleEditBsChange = () => {
    setValue2('amount', (watch2('amountBsS') / dollarByDate)?.toFixed(2));
  };

  const handleAddMethodChange = (e) => {
    const currentMethod = getValues('method');
    const currentAmount = getValues('amount');
    const currentAmountBs = getValues('amountBsS');
    const currentSeller = getValues('seller');
    const currentCreationDate = getValues('creationDate');
    reset({
      method: currentMethod,
      amount: currentAmount,
      amountBsS: currentAmountBs,
      seller: currentSeller,
      creationDate: currentCreationDate,
    });
  };

  const handleDateChange = (e) => {
    getDollarRateByDate(e);
  };

  const showAddAccHolder = () => {
    const payment = filterById(salesPaymentMethods, watch('method'));
    if ([paymentMethods.ZELLE, paymentMethods.PAYPAL].includes(payment?.name)) {
      return true;
    } else {
      return false;
    }
  };

  const isBancamigaPM = (options, method) => {
    let PMpaymentMethod = filterById(options, method);

    if (PMpaymentMethod?.name === paymentMethods.PAGO_MÓVIL_BANCAMIGA) {
      return true;
    } else {
      return false;
    }
  };

  const validateBancamigaPM = async (data) => {
    return bancamigaService
      .checkPayment(data)
      .then((response) => {
        if (response.status === 200) {
          if (response?.data?.wasFound) {
            return true;
          } else {
            notify(`No se pudo validar el pago movil`, 'error');
            return false;
          }
        } else {
          notify(`${response.message}`, 'error');
          return false;
        }
      })
      .catch(() => { });
  };

  const showEditAccHolder = () => {
    const payment = filterById(salesPaymentMethods, watch2('method'));
    if ([paymentMethods.ZELLE, paymentMethods.PAYPAL].includes(payment?.name)) {
      return true;
    } else {
      return false;
    }
  };

  const validatePaymentAction = (id) => {
    if (!id) {
      notify('No se ha encontrado el pago', 'error');
      return;
    }
    if (!isLoading) {
      setIsLoading(true);
      paymentsService
        .updateAdvancedPayment(id, { paymentStatus: 'Aprobado' })
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            setIsLoading(false);
            notify(`Pago validado`, 'success');
            getAdvancedPayments();
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => { });
    }
  };

  const handleOpenModal = (id) => {
    setValidatePaymentModal((prevState) => {
      return {
        ...prevState,
        isOpen: !prevState.isOpen,
        id: id,
      };
    });
  };
  useEffect(() => {
    // getMembershipCashea();
    getAdvancedPayments();
  }, [
    advancedPaymentsTable?.page,
    advancedPaymentsTable?.offset,
    advancedPaymentsTable?.limit,
    advancedPaymentsTable?.type,
    dateFrom,
    dateTo,
  ]);

  const getAdvancedPayments = (byEmail) => {
    let params = {
      from: dateFrom
        ? moment(dateFrom).format('MM-DD-YYYY')
        : moment().subtract(1, 'months').format('MM-DD-YYYY'),
      to: dateTo
        ? moment(dateTo).format('MM-DD-YYYY')
        : moment().format('MM-DD-YYYY'),
      limit: advancedPaymentsTable?.limit,
      page: advancedPaymentsTable.page,
      // offset: advancedPaymentsTable?.offset,
      search: advancedPaymentsTable?.searchParam,
    };

    if (byEmail) {
      params.byEmail = true;
    }

    paymentsService
      .listAdvancedPayment(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          if (byEmail) {
            notify(
              `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
              'info'
            );
          } else {
            setAdvancedPaymentsTable((prevState) => {
              return {
                ...prevState,
                data: response?.data?.payments,
                count: response?.data?.total,
                isLoading: false,
              };
            });
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
          setAdvancedPaymentsTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch((error) => {
        setAdvancedPaymentsTable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
    return true;
  };

  const handleAddModal = () => {
    const currentCreationDate = getValues('creationDate');

    setShowAddModal(!showAddModal);
    setAddFilesUploaded([]);
    reset({
      creationDate: currentCreationDate,
    });
  };

  const closeEditModal = () => {
    reset2();
    setShowEditModal((prevState) => {
      return {
        ...prevState,
        isOpen: false,
        id: '',
      };
    });
  };

  const handleOpenEditModal = (data) => {
    setValue2(
      'creationDate',
      data?.createdAt ? new Date(data?.createdAt) : new Date()
    );
    setValue2('clientPhone', data?.clientPhone);
    setValue2('clientName', data?.customerName);
    setValue2('reference', data?.reference);
    setValue2('method', data?.paymentMethodId);
    setValue2('amountBsS', data?.amountBsS);
    setValue2('amount', data?.amount);
    setValue2('seller', data?.responsibleAdvisorId);
    setValue2('paymentType', data?.paymentType);
    setValue2('casheaRef', data?.casheaRef);
    setValue2('bank', data?.clientBankCode ? data?.clientBankCode : '');
    setValue2('phone', data?.phoneNumber ? data?.phoneNumber : '');
    setValue2(
      'identification',
      data?.identification ? data?.identification : ''
    );
    setValue2('identificationType', data?.identificationType);
    setValue2(
      'paymentDate',
      data?.paymentDate ? new Date(data?.paymentDate) : new Date()
    );
    setShowEditModal((prevState) => {
      return {
        ...prevState,
        id: data?._id,
        isOpen: true,
      };
    });
  };

  useEffect(() => {
    getDollarRateByDate(new Date());
    getSellers();
    getPaymentMethods();
  }, []);

  return (
    <>
      <Header />
      <LoadSpinner show={isLoading} />
      <ValidatePaymentModal
        isOpen={validatePaymentModal?.isOpen}
        id={validatePaymentModal?.id}
        handleModal={handleOpenModal}
        action={validatePaymentAction}
      />

      <AdvancedPaymentModal
        modal={showAddModal}
        register={register}
        action={addAdvancedPayment}
        handleClose={() => handleAddModal()}
        errors={errors}
        control={control}
        options={{
          paymentMethods: salesPaymentMethods,
          dollarRate: dollarByDate,
          sellers: sellers,
          paymentTypesOptions: [
            { name: paymentType.CASHEA, _id: paymentType.CASHEA },
            { name: paymentType.FINANCIADO, _id: paymentType.FINANCIADO },
            { name: paymentType.DE_CONTADO, _id: paymentType.DE_CONTADO },
          ],
        }}
        onChange={{
          handleEditAmountChange: handleAddAmountChange,
          handleEditBsChange: handleAddBsChange,
          handleDateChange: handleDateChange,
          handleMethodChange: handleAddMethodChange,
        }}
        watch={watch}
        addFilesUploaded={addFilesUploaded}
        setAddFilesUploaded={setAddFilesUploaded}
        showAccHolder={showAddAccHolder}
        title={'Registrar Pago'}
      />
      {/* PARA EDICION DE PAGOS */}
      <AdvancedPaymentModal
        modal={showEditModal.isOpen}
        register={register2}
        action={editAdvancedPayment}
        handleClose={() => closeEditModal()}
        errors={errors2}
        control={control2}
        options={{
          paymentMethods: salesPaymentMethods,
          dollarRate: dollarByDate,
          sellers: sellers,
          paymentTypesOptions: [
            { name: paymentType.CASHEA, _id: paymentType.CASHEA },
            { name: paymentType.FINANCIADO, _id: paymentType.FINANCIADO },
            { name: paymentType.DE_CONTADO, _id: paymentType.DE_CONTADO },
          ],
        }}
        onChange={{
          handleEditAmountChange: handleEditAmountChange,
          handleEditBsChange: handleEditBsChange,
          handleDateChange: handleDateChange,
        }}
        watch={watch2}
        addFilesUploaded={addFilesUploaded}
        setAddFilesUploaded={setAddFilesUploaded}
        showAccHolder={showEditAccHolder}
        title={'Editar Pago'}
        isEdit={true}
      />
      <div className="service-with-container container">
        <div className="buttons-container">
          <h1 className="title-component">{`Cobros Anticipados: ${advancedPaymentsTable.count}`}</h1>
          {![
            salesRoles?.SALES_ADMIN,
            salesRoles?.SALES_ADMIN_AUX,
            salesRoles?.SALES_DEVELOPER,
          ].includes(userRole) || user?.type === 'Externo' ? null : (
            <div style={{ display: 'flex' }}>
              <ActionButton
                label="Exportar"
                action={() => {
                  getAdvancedPayments(true);
                }}
              />
            </div>
          )}
        </div>
        <div className="breadcrumb-container">
          <div className="exportables-buttons-container">
            <div style={{ width: '100%' }} className="row">
              <div className="col-12 col-md-2" style={{ marginTop: '30px' }}>
                <SearchInput
                  placeholder={'Nombre o Apellido o Cédula'}
                  searchAction={getAdvancedPayments}
                  value={advancedPaymentsTable?.searchParam}
                  onChange={handleSearchChange}
                  width="50px"
                />
              </div>
              {![
                salesRoles?.SALES_HUNTER,
                salesRoles?.SALES_COUNTER,
                salesRoles?.SALES_FARMER,
                salesRoles?.SALES_ADMIN_AUX,
                salesRoles?.SALES_KEY_ACCOUNTS,
              ].includes(authService?.getUserType()) ? (
                <>
                  <FilterDatePicker
                    bootstrap={'col-12 col-md-2'}
                    label={'Desde'}
                    type={'date'}
                    name={'dateFrom'}
                    placeholder={''}
                    onChange={handleSinceDateChange}
                    value={dateFrom}
                    disabled={advancedPaymentsTable?.isLoading}
                  />
                  <FilterDatePicker
                    bootstrap={'col-12 col-md-2'}
                    label={'Hasta'}
                    type={'date'}
                    name={'dateTo'}
                    placeholder={''}
                    onChange={handleUntilDateChange}
                    value={dateTo}
                    disabled={advancedPaymentsTable?.isLoading}
                  />
                </>
              ) : null}

              <div
                style={{
                  marginTop: '24px',
                  // marginLeft: 'auto',
                  // width: '350px',
                }}
              >
                {![
                  salesRoles?.SALES_FARMER,
                  salesRoles?.SALES_HUNTER,
                  salesRoles?.SALES_COUNTER,
                  salesRoles?.SALES_ADMIN_AUX,
                  salesRoles?.SALES_KEY_ACCOUNTS,
                ].includes(authService?.getUserType()) && (
                    <SelectPerPage
                      label={'Registros por página'}
                      options={itemsPerpage}
                      value={advancedPaymentsTable?.limit}
                      onChange={selectitemsPerpage}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <ActionButton
            label="Registrar Pago Anticipado"
            action={() => {
              handleAddModal();
              setValue('creationDate', new Date());
            }}
          />
        </div>
        <AdvancedPaymentsTable
          header={advancedPaymentsTableHeader}
          data={advancedPaymentsTable}
          handlePageChange={handlePageChange}
          tableRef={tableRef}
          dateFrom={dateFrom}
          dateTo={dateTo}
          action={{
            validate: handleOpenModal,
            edit: handleOpenEditModal,
          }}
          user={user}
          userRole={userRole}
        />
      </div>
    </>
  );
};
